const t = {
  name: "ChevronsRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.58594 12.0002L5.58594 16.0002L7.00015 17.4144L12.4144 12.0002L7.00015 6.58594L5.58594 8.00015L9.58594 12.0002Z" fill="currentColor"/>
<path d="M15.5859 12.0002L11.5859 16.0002L13.0002 17.4144L18.4144 12.0002L13.0002 6.58594L11.5859 8.00015L15.5859 12.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronsRight
};
